import { jsx } from "panel";
import { selx } from "clsx";
import { SectionEl } from "common/components/section";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { TooltipEl } from "common/components/tooltip";
import { BucketSizeEl } from "common/widgets/bucket-sizes";
import { SvgIconEl } from "common/components/svg-icon";
import { mpColors } from "common/util/colors";
import { Directions } from "common/components/drop-menu/types";
import { ButtonSize } from "common/components/button/constants";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { TimeUnit } from "common/widgets/date-range-picker/models/types";
import { CUSTOM_RETENTION_UNIT } from "./constants";
import styles from "./index.module.styl";
const commonTooltipAttrs = {
  size: DisplaySize.Small
};
const CustomBucket = ({
  customRetentionUnitSelected,
  bucketSizes,
  retentionUnit,
  header,
  tooltipPrefix,
  onApplyCustom,
  onCancelCustom
}) => {
  return /* @__PURE__ */ jsx(null, null, customRetentionUnitSelected && /* @__PURE__ */ jsx(TooltipEl, { attrs: { text: `${tooltipPrefix}: ${bucketSizes}` } }), customRetentionUnitSelected && /* @__PURE__ */ jsx(
    BucketSizeEl,
    {
      sel: selx(styles.bucketSizes),
      attrs: {
        header,
        "bucket-unit": retentionUnit,
        "bucket-sizes": bucketSizes
      },
      on: {
        apply: onApplyCustom,
        cancel: onCancelCustom
      }
    }
  ));
};
export function template() {
  const { t } = this.getContext(`i18n`);
  const bucketLength = this.attr(`bucket-sizes`).length;
  const selectedRetentionUnitValue = bucketLength !== 0 ? CUSTOM_RETENTION_UNIT : this.attr(`retention-unit`);
  return /* @__PURE__ */ jsx(
    SectionEl,
    {
      sel: selx(styles.section),
      attrs: {
        "header-title": t(`retention.retention-criteria`),
        "is-container": true,
        "non-collapsible": true
      }
    },
    /* @__PURE__ */ jsx(
      SelectEl,
      {
        sel: selx(styles.select, styles.advancedMenu),
        attrs: {
          slot: `actions`,
          theme: SelectTheme.Tertiary,
          "always-show-caret": true,
          "selected-option": t(`query-builder.advanced`),
          "menu-alignment": Directions.Right,
          size: ButtonSize.Small,
          tooltip: { placement: Placement.Right },
          "experimental-positioning": true,
          "menu-width": 185
        },
        props: {
          sections: [
            {
              items: this.getAdvancedMenuOptions()
            }
          ]
        },
        on: {
          change: this.handleAdvancedMenuChange
        }
      }
    ),
    /* @__PURE__ */ jsx("div", { sel: selx(styles.retentionCriteria) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.iconWrapper) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `stop-watch`, color: mpColors[`$gray3`] } })), /* @__PURE__ */ jsx(
      SelectEl,
      {
        sel: selx(styles.select, styles.methodSelect),
        attrs: {
          "menu-width": 190,
          theme: SelectTheme.Tertiary
        },
        params: {
          sections: [
            {
              items: this.getRetentionUnboundedOptions()
            }
          ]
        },
        on: { change: this.handleChangeCountingMethodSelector }
      }
    ), /* @__PURE__ */ jsx(
      SelectEl,
      {
        sel: selx(styles.select, styles.unitSelect),
        attrs: {
          elref: `retUnitSelector`,
          label: this.getLabel(
            this.attr(`bucket-sizes`),
            this.attr(`retention-unit`),
            this.attr(`retention-alignment-type`)
          ),
          theme: SelectTheme.Tertiary,
          tooltip: this.getUnitSelectorTooltip()
        },
        params: {
          sections: [
            {
              items: [
                {
                  value: TimeUnit.Day,
                  isSelected: selectedRetentionUnitValue === TimeUnit.Day,
                  label: t(`query-builder.retention.interval.day`),
                  tooltip: {
                    text: t(`query-builder.retention.interval.tooltip.day`),
                    ...commonTooltipAttrs
                  }
                },
                {
                  value: TimeUnit.Week,
                  isSelected: selectedRetentionUnitValue === TimeUnit.Week,
                  label: t(`query-builder.retention.interval.week`),
                  tooltip: {
                    text: t(`query-builder.retention.interval.tooltip.week`),
                    ...commonTooltipAttrs
                  }
                },
                {
                  value: TimeUnit.Month,
                  isSelected: selectedRetentionUnitValue === TimeUnit.Month,
                  label: t(`query-builder.retention.interval.month`),
                  tooltip: {
                    text: t(`query-builder.retention.interval.tooltip.month`),
                    ...commonTooltipAttrs
                  }
                },
                {
                  value: CUSTOM_RETENTION_UNIT,
                  isSelected: selectedRetentionUnitValue === CUSTOM_RETENTION_UNIT,
                  label: t(`query-builder.retention.interval.custom`),
                  tooltip: {
                    text: t(`query-builder.retention.interval.tooltip.custom`),
                    ...commonTooltipAttrs
                  }
                }
              ]
            }
          ]
        },
        on: { change: this.handleChangeUnitSelector }
      }
    ), /* @__PURE__ */ jsx(
      CustomBucket,
      {
        customRetentionUnitSelected: this.state.customRetentionUnitSelected,
        bucketSizes: this.attr(`bucket-sizes`),
        retentionUnit: this.attr(`retention-unit`),
        header: t(`query-builder.retention.interval.custom-menu.title`),
        tooltipPrefix: t(`query-builder.retention.interval.custom-menu.returning-users`),
        onApplyCustom: this.handleApplyCustom,
        onCancelCustom: this.handleCancelCustom
      }
    ))
  );
}
